// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton-2lYgC","skeleton-shimmer":"skeleton-shimmer-3N2Jy"};